import { render, staticRenderFns } from "./OrderPrintDeliverField.vue?vue&type=template&id=32657fc2&scoped=true"
import script from "./OrderPrintDeliverField.vue?vue&type=script&lang=js"
export * from "./OrderPrintDeliverField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32657fc2",
  null
  
)

export default component.exports